import {
  RFID_FILE_DOWNLOAD_FAILURE,
  RFID_FILE_DOWNLOAD_REQUEST,
  RFID_FILE_DOWNLOAD_SUCCESS,
} from './types/RfidDownloadActionsTypes';

export function downloadRfidFileRequestActionCreator() {
  return {
    type: RFID_FILE_DOWNLOAD_REQUEST,
  };
}

export function downloadRfidFileSuccessActionCreator() {
  return {
    type: RFID_FILE_DOWNLOAD_SUCCESS,
  };
}

export function downloadRfidFileFailureActionCreator(error) {
  return {
    type: RFID_FILE_DOWNLOAD_FAILURE,
    payload: { error },
  };
}
